import * as React from 'react';
import { RegisterUserForm, LogoCentered} from 'src/app/Partials';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './Register.messages';

import './Register.scss';
import { Link } from 'react-router-dom';

export interface RegisterPageProps {
}

export class RegisterPage extends React.Component<RegisterPageProps, any> {
  public render() {
    return (
      <div className="page-register d-flex justify-content-center align-items-center h-100">
        <div className="inner w-100 pt-5 pb-5">
          <div className="col-12">
            <p className="mb-4">
              <LogoCentered />
            </p>
          </div>
          <div className="col-12">
            <p className="mb-4">
              <FormattedMessage {...MESSAGES.registerText} />
            </p>
          </div>
          <RegisterUserForm />
          <div className="meta d-flex mt-2">
            <div className="col-6 text-left">
              <p className="small">
                <Link to="/">
                  <span>
                    <FormattedMessage {...MESSAGES.registerButton} />
                  </span>
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
